import React, { useEffect, useState } from "react";
import "./AboutPage.css";
import PageTitle from "../components/PageTitle";
import SingleContentSection from "../components/Content/SingleContentSection";
import { BlogEntryItem } from "../utils/types/BlogEntryItem";

const AboutPage: React.FC = () => {
    const aboutPageTitle = "";
    const aboutPageText = "<p>Som púchovský rodák, otec rodiny a človek, ktorého život formoval vrcholový šport, zahraničné skúsenosti a práca v komunálnej politike. Púchov je mojím domovom, miestom, kde mám hlboké korene a ku ktorému cítim úprimnú zodpovednosť. Ako bývalý profesionálny futbalista viem, čo znamená disciplína, tímová práca a ťah na bránu. Tieto vlastnosti, spolu so skúsenosťami z riadenia mestského športového klubu MŠK Púchov a pôsobenia v pozícii poslanca, chcem ponúknuť Vám, občanom Púchova. Moja vízia je jasná: viesť mesto slušne, pokojne, bez konfliktov a s rešpektom voči každej generácii.</p>\
    <p><strong>ŽIVOTNÉ A PROFESIONÁLNE SKÚSENOSTI<\strong><\p>\
    <p><strong>Komunálna politika a manažment<\strong><\p> \
    <p><strong>Poslanec miestneho zastupiteľstva (Bratislava - Petržalka):<\strong><\p>\
    <p>Aktívna práca v samospráve, schvaľovanie rozpočtov, riešenie reálnych problémov obyvateľov najväčšieho sídliska na Slovensku a hľadanie praktických riešení v doprave a parkovaní.<\p> \
    <p><strong>Konateľ, MŠK Púchov (Mestský športový klub)<\strong><\p> \
    <p>Manažérske riadenie mestského podniku, zodpovednosť za efektívne hospodárenie s verejnými financiami, rozvoj športovej infraštruktúry a podpora mládežníckeho aj profesionálneho športu v meste.<\p> \
    <p><strong>Profesionálna športová kariéra a zahraničie<\strong><\p> Bývalý profesionálny futbalista a reprezentant: Dlhoročná kariéra na najvyššej úrovni, držiteľ ocenenia Kráľ ligových strelcov. Šport ma naučil nevzdávať sa, rešpektovať pravidlá fair-play a pracovať pre spoločný výsledok. Pôsobenie v zahraničí: Roky strávené v medzinárodnom prostredí mi rozšírili obzory. Videl som, ako fungujú moderné, čisté a bezpečné európske mestá. Tieto overené prístupy k doprave, čistote a správe vecí verejných chcem preniesť k nám domov.</p>";

    const [currentItemContent, setCurrentItemContent] = useState<string>("");
    const [currentItemTitle, setCurrentItemTitle] = useState<string>("");
    useEffect(() => {
        const data = localStorage.getItem("main-articles");
        if (data) {
            const items = JSON.parse(data) as BlogEntryItem[];
            const item = items.filter(i => (i.blog.category === "mainContent" && i.meta.url == "o-mne"))[0];
            if (item) {
                setCurrentItemContent(item.blog.content);
                setCurrentItemTitle(item.blog.title);
            }
        }
    })

    return (
        <div>
            <PageTitle pageName="" desc="" id="lubomir-luhovy"/>
            <SingleContentSection title={aboutPageTitle} text={currentItemContent} itemUrl="o-mne" />
        </div>
    );
}

export default AboutPage;